import { Component, Input, OnInit } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { ApplicationType } from 'src/app/services/dtos'

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'about-real-time-replication',
  templateUrl: './about-real-time-replication.component.html',
  styleUrls: ['./about-real-time-replication.component.scss'],
  standalone: false,
})
export class AboutRealTimeReplicationComponent implements OnInit {
  @Input() applicationType: ApplicationType = ApplicationType.AWS

  ApplicationType = ApplicationType

  constructor(private uiService: UiService) {}

  ngOnInit(): void {}

  get rtReplicationDocsUrl(): string {
    return this.uiService.rtReplicationDocsUrl
  }

  get isAws(): boolean {
    return this.applicationType === ApplicationType.AWS
  }

  get isAzure(): boolean {
    return this.applicationType === ApplicationType.AZURE
  }
}
